<div id="cobrowsing-panel" class="panel">
  <div class="panel-title">
    <h3 class="title">{{ 'agent:contact.workspace.phone.cobrowsing.title' | translate }}</h3>
    <span *ngIf="currentSessionCode" class="session-code cng-ico_ticket">{{ currentSessionCode }}</span>
  </div>

  <div class="panel-body panel-body-qualif" [class]="isCobrowsingInProgress ? 'hidden' : ''">
    <mat-stepper horizontal [selectedIndex]="initialStep" [linear]="false" labelPosition="bottom" #stepper>
      <mat-step [stepControl]="form" [completed]="stepper.selectedIndex > 0">
        <ng-template matStepperIcon="edit" let-index="index">{{ index + 1 }}</ng-template>
        <ng-template matStepLabel>{{ 'agent:contact.workspace.phone.cobrowsing.step1' | translate }}</ng-template>
      </mat-step>
      <mat-step [completed]="stepper.selectedIndex > 0" [aria-labelledby]="stepper.selectedIndex > 0 ? '' : 'disabled_step'">
        <ng-template matStepperIcon="edit" let-index="index">{{ index + 1 }}</ng-template>
        <ng-template matStepLabel>{{ 'agent:contact.workspace.phone.cobrowsing.step2' | translate }}</ng-template>
      </mat-step>
    </mat-stepper>

    <form
      *ngIf="stepper.selectedIndex == 0 && maxSessionsReached != undefined"
      id="cobrowsing-code"
      [formGroup]="form"
      (submit)="validateCode()"
      autocomplete="off"
    >
      <fieldset>
        <legend>{{ 'agent:contact.workspace.phone.cobrowsing.form.legend' | translate }}</legend>
        <mat-form-field>
          <input matInput [formControlName]="FormField.CODE" type="text" required maxlength="6" />
          <mat-label>{{ 'agent:contact.workspace.phone.cobrowsing.form.fieldName' | translate }}</mat-label>
          <mat-error *ngIf="form.controls[FormField.CODE].invalid">{{
            'agent:contact.workspace.phone.cobrowsing.form.error' | translate
          }}</mat-error>
        </mat-form-field>
      </fieldset>
      <button type="submit" class="step2-validate" color="accent" mat-flat-button [disabled]="form.controls[FormField.CODE].invalid">
        <mat-icon>validate</mat-icon>
        {{ 'agent:actions.validate' | translate }}
      </button>
    </form>

    <div *ngIf="stepper.selectedIndex == 1" class="step2">
      <cng-form-hint type="info" *ngIf="infoMessageLabelKey && !errorMessageLabelKey">
        <p>{{ 'agent:contact.workspace.phone.cobrowsing.messages.' + infoMessageLabelKey | translate }}</p>
      </cng-form-hint>
      <cng-form-hint type="danger" *ngIf="errorMessageLabelKey">
        <p>{{ 'agent:contact.workspace.phone.cobrowsing.messages.' + errorMessageLabelKey | translate }}</p>
      </cng-form-hint>
      <button *ngIf="maxSessionsReached" type="button" color="primary" mat-flat-button (click)="checkIfMaxSessionsNumberIsReached(true)">
        {{ 'agent:contact.actions.retry' | translate }}
      </button>
      <button
        *ngIf="maxSessionsReached === false && errorOccurredDuringSessionApiCall === false"
        type="button"
        color="primary"
        mat-flat-button
        (click)="closeSession(true)"
      >
        <mat-icon>arrow2_left</mat-icon>
        {{ 'agent:contact.actions.back' | translate }}
      </button>
    </div>
  </div>
  <div class="cobrowsing-inprogress">
    <div class="cobrowsing-tools" [class]="isCobrowsingInProgress ? '' : 'hidden'">
      <button
        type="button"
        mat-icon-button
        title="{{ 'agent:contact.workspace.phone.cobrowsing.tools.laser' | translate }}"
        (click)="setTool(ToolName.laser)"
        [class]="{ 'active-button': isLaserToolSelected }"
      >
        <mat-icon>laser</mat-icon>
      </button>
      <button
        mat-icon-button
        type="button"
        title="{{ 'agent:contact.workspace.phone.cobrowsing.tools.drawing' | translate }}"
        (click)="setTool(ToolName.drawing)"
        [class]="{ 'active-button': !isLaserToolSelected }"
      >
        <mat-icon>edit_pen</mat-icon>
      </button>
      <button
        mat-icon-button
        type="button"
        title="{{ 'agent:contact.workspace.phone.cobrowsing.tools.clear' | translate }}"
        (click)="clearAnnotations()"
      >
        <mat-icon>delete</mat-icon>
      </button>
      <button
        mat-icon-button
        type="button"
        title="{{ 'agent:contact.workspace.phone.cobrowsing.actions.close' | translate }}"
        (click)="closeSession(false)"
      >
        <mat-icon>close_sharing</mat-icon>
      </button>
    </div>
    <div #cobrowseContainer class="panel-body cobrowsing-container" [class]="isCobrowsingInProgress ? 'in-progress' : ''"></div>
  </div>
</div>
